export default __webpack_public_path__ + "static/media/fill-2x.3b3a974f.svg";